import {
  HIDE_MODAL_LOADING,
  HIDE_PAGE_LOADING,
  HIDE_SECTION_LOADING,
  SET_AVAILABLE_GAMES,
  SHOW_MODAL_LOADING,
  SHOW_PAGE_LOADING,
  SHOW_SECTION_LOADING,
} from "./actions";
const defaultObj = {
  showSectionLoader: false,
  showPageLoader: false,
  showModalLoader: false,
  availableGames: [],
};

export const UtilityReducer = (state = defaultObj, action) => {
  switch (action.type) {
    case SHOW_SECTION_LOADING:
      return {
        ...state,
        showSectionLoader: true,
      };
    case HIDE_SECTION_LOADING:
      return {
        ...state,
        showSectionLoader: false,
      };
    case SHOW_PAGE_LOADING:
      return {
        ...state,
        showPageLoader: true,
      };
    case HIDE_PAGE_LOADING:
      return {
        ...state,
        showPageLoader: false,
      };
    case SHOW_MODAL_LOADING:
      return {
        ...state,
        showModalLoader: true,
      };
    case HIDE_MODAL_LOADING:
      return {
        ...state,
        showModalLoader: false,
      };
    case SET_AVAILABLE_GAMES:
      return {
        ...state,
        availableGames: action.payload,
      };
    default:
      return state;
  }
};
